import './Connection.css';
import React, { useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";
import { withTranslate } from 'react-redux-multilingual';
import { connect } from 'react-redux';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Button from '@mui/material/Button';
import Pagination from '@mui/material/Pagination';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Tooltip from '@mui/material/Tooltip';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import AddIcon from '@mui/icons-material/Add';
import AddCardTwoToneIcon from '@mui/icons-material/AddCardTwoTone';

import ConnectionDialog from '../../blocks/ConnectionDialog/ConnectionDialog';

import Gmail from '../../../libraries/Icons/gmail.png';
import GoogleDrive from '../../../libraries/Icons/GoogleDrive.png';
import GoogleCalendar from '../../../libraries/Icons/GoogleCalendar.png';
import GoogleDocs from "../../../libraries/Icons/GoogleDocs.png";
import GoogleSpreadsheets from '../../../libraries/Icons/GoogleSpreadsheets.png';
import AwsS3 from '../../../libraries/Icons/AwsS3.png';
import Ftp from '../../../libraries/Icons/Ftp.png';
import Filemaker from '../../../libraries/Icons/Filemaker.png';

import { 
    GetConnection,
    SaveToken,
    DeleteConnection,
} from '../../../services/Connection.service';
import { getEndpointURL } from '../../../services/config';

const io = require("socket.io-client");
const baseURL = getEndpointURL();

const innerHeight = window.innerHeight;

function Connection(props) {
    const { translate, SnackbarAlert, ConfirmDialog } = props;
    const { param } = useParams();
    const [conections, setConnections] = React.useState([]);
    const [openConnectionDialog, setOpenConnectionDialog] = React.useState(false);
    const [searchConnection, setSearchConnection] = React.useState("");
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const [pageCount, setPageCount] = React.useState(0);
    const [page, setPage] = React.useState(0);

    const connectionInforRef = useRef();
    const socketRef = useRef();

    const CardImage = ({name, size}) => (
        <>
        {
            name === 'Gmail' ? <img src={Gmail} width={size} /> :
            name === 'Google Drive' ? <img src={GoogleDrive} width={size} /> :
            name === 'Google Calendar' ? <img src={GoogleCalendar} width={size} /> :
            name === 'Google Docs' ? <img src={GoogleDocs} width={size} /> :
            name === 'Google Spreadsheets' ? <img src={GoogleSpreadsheets} width={size} /> :
            name === 'AWS S3' ? <img src={AwsS3} width={size} /> :
            name === 'FTP' ? <img alt="" src={Ftp} height={size} /> :
            name === 'Filemaker' ? <img src={Filemaker} width={size} /> :
            ""
        }
        </>
    )

    const onInit = ({ backDrop }) => {
        if(backDrop) props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: true });
        GetConnection(searchConnection, rowsPerPage, page)
        .then(res => {
            // console.log(res)
            setPageCount(Math.ceil(res.data.datas[0][0]?.count / rowsPerPage));
            setConnections(res.data.datas[1]);
        })
        .catch(err => {
            navigator("/signin");
        })
        .finally(() => {
            setTimeout(() => {
                props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: false });
            }, 1000);
        })
    }

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        setRowsPerPage(event.target.value);
    };
    const handleChangePage = (event, value) => {
        setPage(parseInt(value) - 1);
    };

    const handleCloseConnectionDialog = () => {
        setOpenConnectionDialog(false);
    };

    const handleOpenConnectionDialog = () => {
        connectionInforRef.current = {};
        setOpenConnectionDialog(true);
    };

    const handleClickUpdate = (name, providerID) => {
        connectionInforRef.current = { name, providerID };
        setOpenConnectionDialog(true);
    }

    const handleClickDelete = (name, providerID) => {
        props.dispatch({ 
            type: 'UPDATE_CONFIRMDIALOG', 
            ConfirmDialog: {
                open: true,
                title: translate('delete'),
                message: translate('deleteconnectionconfirm', { name }),
                buttonName: translate('delete'),
                onClose: () => onCloseConfirmDialog(),
                onAgree: () => onAgreeConfirmDialog(providerID)
            } 
        });
    }

    const onCloseConfirmDialog = () => {
        props.dispatch({ type: 'UPDATE_CONFIRMDIALOG', ConfirmDialog: {...ConfirmDialog, open: false} });
    }
    
    const onAgreeConfirmDialog = (connectionID) => {
        let event;
        onCloseConfirmDialog();
        event = DeleteConnection(connectionID);
        event?.then(res => {
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
                onInit({ backDrop: false });
            }, 1000)
        })
        .catch(err => {
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
        })
    }

    const handleCloseSnackbarAlert = () => {
        props.dispatch({ type: 'UPDATE_SNACKBARALERT', SnackbarAlert: { ...SnackbarAlert, open: false } });
    }

    const handleCopyConnection = (providerID) => {
        navigator.clipboard.writeText(providerID);
        props.dispatch({ 
            type: 'UPDATE_SNACKBARALERT', 
            SnackbarAlert: {
                open: true,
                severity: 'success',
                message: translate('copiedtoclipboard'),
                handleClose: () => handleCloseSnackbarAlert()
            } 
        });
    }

    useEffect(() => {
        const getData = setTimeout(() => {
            onInit({ backDrop: false });
        }, 500)
        return () => clearTimeout(getData)

    }, [searchConnection, rowsPerPage, page])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        onInit({ backDrop: true });
    }, [])

    useEffect(() => {
        if(!param) {
            socketRef.current = io(baseURL);
            socketRef.current.on("update-connection-record", () => {
                onInit({ backDrop: true }); 
            });
            socketRef.current.on("auth-connection-google", (data) => {
                // console.log(data)
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: data?.status,
                        message: translate(`${data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    }
                });
            });
            setTimeout(() => {
                localStorage.setItem("_socketID", socketRef.current.id)
            }, 1000);
            return () => {
                socketRef.current.disconnect();
            };
        }
    }, [searchConnection])

    useEffect(() => {
        let event;
        const code = new URLSearchParams(window.location.search).get("code");
        const socket = io(baseURL, { secure: true, reconnect: true, rejectUnauthorized: false });
        const connectionInfor = JSON.parse(localStorage.getItem('_connectionInfor'));
        localStorage.removeItem("_connectionInfor");
        window.scrollTo({ top: 0, behavior: "smooth" });
        
        if(param === 'auth' && connectionInfor)
            event = SaveToken(code, connectionInfor?.name, connectionInfor?.providerID);

        event?.then(res => {
            // console.log(res)
            socket.emit("auth-connection-google", localStorage.getItem('_socketID'), res?.data);
            window.close();
        })
        .catch(err => {
            // console.log(err)
            socket.emit("auth-connection-google", localStorage.getItem('_socketID'), err?.response?.data);
            window.close();
        })
    }, [])

    return (
        <Container maxWidth="xl">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Box className='connection-box'>
                        <Grid container spacing={0}>
                            <Grid item xs={12}>
                                <Box sx={{ 
                                        p: 1, 
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        borderBottom: '1px solid rgb(229, 234, 242)'
                                    }}>
                                    <Box className='search-box'>
                                        <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                                            <SearchIcon />
                                        </IconButton>
                                        <InputBase
                                            type="search"
                                            sx={{ ml: 1, flex: 1 }}
                                            placeholder={translate('search')}
                                            onChange={(e) => setSearchConnection(e.target.value)}
                                        />
                                    </Box>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                        <Box>
                                            <Button variant="contained" disableElevation startIcon={<AddIcon />} onClick={handleOpenConnectionDialog}>{translate('addnew')}</Button>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{ overflowY: "auto", height: (innerHeight - 64 - 61 - 18), position: "relative" }}>
                                    <Box className='position-sticky-top backdrop-filter' display="flex" justifyContent="space-between" p={2}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <span>{translate('rowsperpage')}:</span>
                                            <FormControl sx={{ mr: 1 }} size="small">
                                                <Select
                                                    value={rowsPerPage}
                                                    onChange={handleChangeRowsPerPage}
                                                    displayEmpty
                                                    autoWidth
                                                    sx={{ "& > div": { padding: "5px 10px" }, "& > fieldset": { borderColor: "rgb(229, 234, 242)" } }}
                                                >
                                                    {[50, 100, 200].map(item => (
                                                        <MenuItem value={item}>{item}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <Pagination 
                                            shape="rounded" 
                                            count={pageCount}
                                            page={page + 1}
                                            onChange={handleChangePage}
                                            color="primary" 
                                        />
                                    </Box>
                                    {conections?.length === 0 &&
                                    <Box sx={{ position: "absolute", width: "100%", top: "30%", textAlign: "center" }}>
                                        <AddCardTwoToneIcon sx={{ fontSize: "200px", color: "#4152691a" }} />
                                        <Typography variant="h5" sx={{ color: "#9999998c", textAlign: "center" }}>
                                        {translate('createyouritemandstartexperimentingnow', { item: `${translate('connection').toLowerCase()}` })}
                                        </Typography>
                                    </Box>}
                                    <Box className='main'>
                                        {conections.map((card) => (
                                            <Card key={card.ID} className='card'>
                                                <CardContent>
                                                    <Box display="flex" gap={1}>
                                                        <Box>
                                                            <CardImage name={card.name} size={48} />
                                                        </Box>
                                                        <Box>
                                                            <Typography variant="h6" component="div" sx={{ color: "rgba(32, 33, 36)" }}>
                                                            {card.name}
                                                            </Typography>
                                                            <Typography variant="body2" component="div" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
                                                            {card.subtitle}
                                                            </Typography>
                                                            <Typography variant="body2" component="div" sx={{ mt: 2, color: "rgba(0, 0, 0, 0.6)" }}>
                                                            {translate('providerid')}:
                                                            </Typography>
                                                            <Typography variant="body2" component="div" sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
                                                            {card.providerID}
                                                                <Tooltip title={translate('clicktocopy')}>
                                                                    <IconButton size='small' onClick={() => handleCopyConnection(card.providerID)}>
                                                                        <ContentCopyIcon fontSize='small' />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </CardContent>
                                                <CardActions>
                                                    <Box width="100%" display="flex" justifyContent="space-between" alignItems="center" gap={1}>
                                                        <Box>
                                                            <Typography variant="body2" component="div" sx={{ color: "rgba(0, 0, 0, 0.6)", display: "flex", alignItems: "center", maxWidth: "185px", overflow: "hidden", whiteSpace: "nowrap" }}>
                                                                <span class="material-symbols-outlined" style={{ fontSize: 14 }}>person</span>&nbsp;{card.firstName}&nbsp;{card.lastName}
                                                            </Typography>
                                                        </Box>
                                                        <Box display="flex" gap={1}>
                                                            <Button size='small' variant="outlined" color="error" onClick={() => handleClickDelete(card.name, card.providerID)}>{translate('delete')}</Button>
                                                            <Button size='small' variant="outlined" onClick={() => handleClickUpdate(card.name, card.providerID)}>{translate('update')}</Button>
                                                        </Box>
                                                    </Box>
                                                </CardActions>
                                            </Card>
                                        ))} 
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
            <ConnectionDialog 
                open={openConnectionDialog}
                handleClose={handleCloseConnectionDialog}
                connectionInfor={connectionInforRef.current}
            />
        </Container>
    );
}
function mapStateToProps(state) {
    return {
        BackDrop: state.BackDrop,
        SnackbarAlert: state.SnackbarAlert,
        ConfirmDialog: state.ConfirmDialog,
    }
}
export default connect(mapStateToProps)(withTranslate(Connection));
